import { createAsyncThunk } from '@reduxjs/toolkit';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';

const updateProfileImage = createAsyncThunk('updateProfileImage', async (formData: FormData) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const response = await fetch(_commonUrls.uploadImg, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error uploading file: ${error.message}`);
  }
});

export default updateProfileImage;
